module.exports = __webpack_public_path__ + "img/p_20_s.dfb238cd.png";